import { z } from 'zod';

import { AUSTRALIAN_STATES } from 'src/constants/constants';

const regoErrorMessage = 'Please enter a valid registration plate';
const stateErrorMessage = 'Please select a state';
const vinErrorMessage = 'Please enter a valid VIN';

const MAX_REGO_LENGTH = 7;
const VALID_REGO_PATTERN = /^[A-Za-z0-9 ]+$/;
const MAX_VIN_LENGTH = 17;

const checkValidRego = (value: string | undefined) => {
  if (!value) return false;
  if (!VALID_REGO_PATTERN.test(value)) return false;
  return value.replace(/\s/g, '').length <= MAX_REGO_LENGTH;
};

export const tradeInSearchCarRegoSchema = z.object({
  rego: z.string().refine(checkValidRego, {
    message: regoErrorMessage,
  }),
  state: z.enum(AUSTRALIAN_STATES, stateErrorMessage),
});

export const tradeInSearchCarVINSchema = z.object({
  vin: z
    .string(vinErrorMessage)
    .min(MAX_VIN_LENGTH, 'The VIN you entered was too short. Please enter a valid VIN with exactly 17 characters.')
    .max(MAX_VIN_LENGTH, 'The VIN you entered was too long. Please enter a valid VIN with exactly 17 characters.'),
});
